module.exports = __webpack_public_path__ + "static/media/car_bg_hover.a2c7c146.png";